module.exports = __webpack_public_path__ + "img/imgQuestion.8ff5d662.png";